(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    mainFunc();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      #MainContent .shopify-section:first-child .collection-title {
        position: relative;
      }

      .product-compare-group__button {
        display: none !important;
      }
      .tv_compare_btn {
        display: block !important;
      }

      .tv_compare_popup .details-title {
        padding: 1rem 0.5rem;
        margin: 0px;
        margin-bottom: 1rem;
        border-bottom: 1px solid black;
        font-weight: 700;
        font-size: 26px;
      }
      .tv_compare_popup p {
        margin: 0px;
      }
      .tv_compare_popup p.details-value {
        margin-bottom: 1rem;
      }
      .tv_compare_popup table {
        table-layout: fixed;
        margin-bottom: 0;
        overflow-x: auto;
      }
      .tv_compare_popup table th {
        padding-block: 0;
        font-size: 14px;
      }
      .tv_compare_popup table td {
        padding-top: 0;
        padding-bottom: 1rem;
        vertical-align: top;
        font-size: 14px;
      }
      .tv_compare_popup table td.tv-size {
        font-size: 32px;
        font-weight: 700;
      }
      .tv_compare_popup table th:last-child,
      .tv_compare_popup table td:last-child {
        display: none;
      }
      table[data-section='summary'] td {
        padding-bottom: 2rem;
      }
      table[data-section='summary'] td img {
        max-width: 100px;
      }
      @media (min-width: 1024px) {
        .tv_compare_btn {
          position: absolute;
          top: 0;
          right: 0;
        }
        .tv_compare_popup .details-title {
          font-size: 32px;
        }
        .tv_compare_popup table th,
        .tv_compare_popup table td {
          font-size: 16px;
        }
        .tv_compare_popup table th:last-child,
        .tv_compare_popup table td:last-child {
          display: block;
        }
        table[data-section='summary'] td img {
          max-width: 180px;
        }
      }
    `;
    document.head.append(style);
  }

  function mainFunc() {
    const body = document.body;
    const popup = document.querySelector(".tv_compare_popup");
    if (body && popup) {
      addStyle();
      body.prepend(popup);
    } else {
      return;
    }

    repositionButton();

    $(".tv_compare_btn").on("click", function () {
      $(".tv_compare_popup").addClass("active");
      document.body.style.overflow = "hidden";
    });
    $(".tv_compare_popup_close_btn").on("click", function () {
      $(".tv_compare_popup").removeClass("active");
      document.body.style.overflow = "";
    });
    $(".tv_compare_popup .section_select .select").on("click", function (e) {
      $(this).toggleClass("open");
    });
    $(".tv_compare_popup .section_select .select .option").on(
      "click",
      function (e) {
        e.stopPropagation();
        $(this).closest(".select.open").removeClass("open");
        $(this).siblings(".selected").removeClass("selected");
        $(this).addClass("selected");
        $(this).closest(".select").find(".trigger span").text($(this).text());

        const blockId = $(this).attr("data-block_id");
        const compareList = $(this).closest(".compare_list");
        const index = $(this).closest(".section_select").attr("data-index");
        const option_index = $(this).index();

        compareList
          .find(`.section_prodInfo[data-index='${index}'] .options button`)
          .addClass("hide");
        compareList
          .find(
            `.section_prodInfo[data-index='${index}'] .options button[data-block_id='${blockId}']`,
          )
          .removeClass("hide");
        compareList
          .find(
            `.section_prodInfo[data-index='${index}'] .options button[data-block_id='${blockId}']`,
          )
          .first()
          .click();
      },
    );
    $(".tv_compare_popup .section_prodInfo .options button").on(
      "click",
      function () {
        $(this).siblings(".selected").removeClass("selected");
        $(this).addClass("selected");

        const compareList = $(this).closest(".compare_list");
        const index = $(this).closest(".section_prodInfo").attr("data-index");
        const prodInfo = compareList.find(
          `.section_prodInfo[data-index='${index}']`,
        );

        compareList
          .find(`.section_prodImg[data-index='${index}'] img`)
          .attr("src", $(this).attr("data-image"));
        prodInfo.find(".price-wrapper").text($(this).attr("data-price"));
        prodInfo
          .find(".product-price__price.product-compare")
          .text($(this).attr("data-compare_at_price"));
        prodInfo
          .find(".cta_wrapper a")
          .attr("href", `/products/${$(this).attr("data-handle")}`);
        prodInfo.find(".cta_wrapper a").text($(this).attr("data-cta_text"));

        addDetails();
      },
    );

    addDetails();
  }

  function repositionButton() {
    $("#MainContent .shopify-section:first-child .collection-title").append(
      $(".tv_compare_btn"),
    );
  }

  function addDetails() {
    const details = getDetails();
    const headers = getDetailHeaders();
    const handles = getCurrentSelected();

    const compareList = $(".compare_list");
    const details_wrapper =
      document.querySelector(".details_wrapper") ||
      document.createElement("div");
    details_wrapper.classList.add("details_wrapper");
    details_wrapper.style.gridColumn = "1 / -1";

    // Total: 52
    const myOrder = [
      {
        title: "Summary",
        length: 12,
      },
      {
        title: "Display",
        length: 14,
      },
      {
        title: "Audio",
        length: 5,
      },
      {
        title: "Features",
        length: 8,
      },
      {
        title: "Size & Weight",
        length: 5,
      },
      {
        title: "Connectivity",
        length: 11,
      },
    ];

    details_wrapper.innerHTML = `
      ${myOrder
        .map((order, index) => {
          const { title, length } = order;
          const isSummary = index == 0;

          let startPos = 0;
          if (index > 0) {
            let x = index;
            while (x > 0) {
              startPos += myOrder[x - 1].length;
              x--;
            }
          }

          return `
            <p class="details-title">${title}</p>
            <table data-section="${title.toLowerCase()}">
              ${
                isSummary
                  ? `
                    <tr>
                      <td class="tv-size">${`${$(`.section_prodInfo[data-index="1"] .options button[data-handle="${handles[0]}"]`).html()}`}</td>
                      <td class="tv-size">${`${$(`.section_prodInfo[data-index="2"] .options button[data-handle="${handles[1]}"]`).html()}`}</td>
                      <td class="tv-size">${`${$(`.section_prodInfo[data-index="3"] .options button[data-handle="${handles[2]}"]`).html()}`}</td>
                    </tr>
                  `
                  : ""
              }
              ${[...Array(length).keys()]
                .map((x) => {
                  // temporary solution for hiding Bluetooth Audio
                  if (x + startPos == 38) return;

                  let template = "";
                  if (!isSummary) {
                    template += `
                    <tr>
                      ${[...Array(3).keys()]
                        .map((y) => {
                          // temporary solution for HLG to DLG for 2026 models
                          const models2026 = [
                            "q43u-2026",
                            "q55u-2026",
                            "q65u-2026",
                            "q75u-2026",
                            "q85u-2026",
                            "q43qe-2026",
                            "q55qe-2026",
                            "q65qe-2026",
                            "q75qe-2026",
                            "u55-2026",
                            "u65-2026",
                            "u75-2026",
                          ];
                          if (
                            models2026.includes(handles[y]) &&
                            x + startPos == 22
                          ) {
                            return `<th>DLG</th>`;
                          }
                          return `<th>${headers[x + startPos - 12]}</th>`;
                        })
                        .join("")}
                    </tr>
                    <tr>
                      ${[...Array(3).keys()]
                        .map((y) => {
                          return `<td>${details[handles[y]][x + startPos]}</td>`;
                        })
                        .join("")}
                    </tr>`;
                  } else {
                    template += `
                    <tr>
                      ${[...Array(3).keys()]
                        .map((y) => {
                          const url = details[handles[y]][x + startPos];
                          if (url) {
                            return `<td><img src="${details[handles[y]][x + startPos]}" alt="" width="" height="" /></td>`;
                          }
                          return `<td></td>`;
                        })
                        .join("")}
                    </tr>`;
                  }

                  return template;
                })
                .join("")}
            </table>
          `;
        })
        .join("")}
    `;

    compareList.append(details_wrapper);
  }

  function getCurrentSelected() {
    let selected = [];

    $(".section_prodInfo button.selected:not(.hide)").each(function (_, x) {
      selected.push($(x).attr("data-handle"));
    });

    return selected;
  }

  function getDetails() {
    const icons = getIcons();

    const details = {
      "default-settings": [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      // Q Series Ultra 2026
      "q43u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "260 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.2 x 73.2 x 559.7 mm",
        "957.2 x 238.5 x 608.4 mm",
        "5.7 kg",
        "5.9 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 959.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q85u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "400 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1890 x 91.3 x 1081.1 mm",
        "1890 x 398.3 x 1176.7 mm",
        "28.8 kg",
        "29.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Ultra Series
      "prism-q55-ultra": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "QLED+",
        "4K (3840x2160)",
        "118% DCI-P3",
        "N/A",
        "N/A",
        "316 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 721 mm",
        "1225 x 290 x 775 mm",
        "9.86 kg",
        "10.06 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-q75-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED+",
        "4K (3840x2160)",
        "91% DCI-P3",
        "N/A",
        "N/A",
        "447 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667 x 87 x 965 mm",
        "1667 x 320 x 1025 mm",
        "20.06 kg",
        "20.40 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-q100-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED",
        "4K (3840x2160)",
        "90% DCI-P3",
        "5000:1",
        "N/A",
        "600 nits",
        "N/A",
        "120Hz",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W + 2 x 10W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "2240 x 90 x 1270 mm",
        "2240 x 425 x 1350 mm",
        "72 kg",
        "73.50 kg",
        "800 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q QE Series 2026
      "q43qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "60Hz",
        "N/A",
        "HDR10",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.4 x 80.6 x 556.2 mm",
        "957.4 x 229.4 x 608.5 mm",
        "6.4 kg",
        "6.5 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "270 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 955.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Series QE
      "q55qe-a-q55qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "93% DCI-P3",
        "N/A",
        "N/A",
        "340 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 726 mm",
        "1225 x 260 x 782 mm",
        "9.74 kg",
        "9.92 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-a-q65qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "85% DCI-P3",
        "N/A",
        "N/A",
        "314 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1447 x 80 x 840 mm",
        "1447 x 290 x 910 mm",
        "14.66 kg",
        "14.92 kg",
        "400 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series 2026
      "u55-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "92% DCI-P3",
        "1,000,000:1",
        "N/A",
        "900 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1225.8 x 77.3 x 713.3 mm",
        "1225.8 x 291.5 x 776.3 mm",
        "12.5 kg",
        "12.8 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1445.2 x 78 x 834.2 mm",
        "1445.2 x 336.7 x 901.9 mm",
        "18 kg",
        "18.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1667.3 x 78.3 x 959.3 mm",
        "1667.3 x 374.6 x 1026.5 mm",
        "25.5 kg",
        "26.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series
      "prism-u55-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "550 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1233 x 88 x 721 mm",
        "1233 x 254 x 757 mm",
        "15.1 kg",
        "18.7 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate)",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1453 x 290 x 881 mm",
        "1453 x 88 x 845 mm",
        "22.5 kg",
        "27.8 kg",
        "400 x 200",
        "1",
        "2",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1675 x 330 x 1008 mm",
        "1675 x 88 x 973 mm",
        "32.9 kg",
        "40.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1925 x 97 x 1109 mm",
        "1925x 380 x 1144 mm",
        "43.8 kg",
        "55 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Ultra-Series
      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "1750 nits",
        "720",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1233 x 86.8 x 771.5 mm",
        "1233 x 230 x 721.6 mm",
        "14.9 kg",
        "15.2 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "107% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2250 nits",
        "1152",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1452.5 x 87.17 x 845.26 mm",
        "1452.5 x 324.92 x 904.14 mm",
        "22.2 kg",
        "22.6 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "114% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2040 nits",
        "1440",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1674.5 x 86.8 x 973.3 mm",
        "1674.5 x 325 x 1030.9 mm",
        "32.4 kg",
        "32.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2320 nits",
        "1800",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1924.8 x 95.4 x 1109.4 mm",
        "1924.8 x 379.9 x 1178.4 mm",
        "43.0 kg",
        "43.8 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // S Series
      "s32-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "HD (1366 x 768)",
        "114% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "718 x 70.2 x 426.8 mm",
        "718 x 177.6 x 466.6 mm",
        "3.48 kg",
        "3.52 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s40-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "117% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "892 x 74.2 x 510.6 mm",
        "892 x 211.8x 556.6 mm",
        "4.7 kg",
        "4.81 kg",
        "200 x 100",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s43-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "106% sRGB",
        "N/A",
        "N/A",
        "228 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "954.5 x 75.4 x 558.6 mm",
        "954.5 x 211.8 x 602.8 mm",
        "5.45 kg",
        "5.5 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // AL Series
      "prism-55al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "1,500,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 50 x 710 mm",
        "1225 x 260 x 756 mm",
        "18.7 kg",
        "20.5 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-65al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "1,500,000:1",
        "N/A",
        "700 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1450 x 50 x 835 mm",
        "1450 x 260 x 880 mm",
        "23 kg",
        "24.7 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
    };

    return details;
  }

  function getDetailHeaders() {
    const headers = [
      "Panel Technology",
      "Resolution",
      "Colour Gamut",
      "Contrast Ratio",
      "Typical Brightness",
      "Peak Brightness",
      "Zones",
      "Refresh Rate",
      "Motion Rate",
      "HDR",
      "HLG",
      "Filmmaker Mode",
      "MEMC Motion Smoothing",
      "Dolby Vision",

      "Sound Output Speakers (Peak Power)",
      "Sound Output Subwoofer (Peak Power)",
      "Dolby Atmos",
      "Dbx-TV",
      "DTS TruSurround",

      "AI Processor",
      "App store",
      "Compatible Apps",
      "Casting",
      "Google Assistant Voice Control",
      "Digital TV Tuner",
      "Eye Care",
      "Bluetooth Audio",

      "Dimension w/o stand (LxWxH)",
      "Dimension w/ stand (LxWxH)",
      "Net Weight w/o stand",
      "Net Weight w/ stand",
      "VESA Mounting",

      "HDMI 2.1 with Enhanced Audio Return Channel (eARC)",
      "HDMI 2.1",
      "HDMI 2.0",
      "USB 2.0",
      "USB 3.0",
      "AV Input",
      "RF Input",
      "Ethernet Lan",
      "SPDIF Out",
      "Wi-Fi",
      "Bluetooth",
    ];

    return headers;
  }

  function getIcons() {
    const icons = {
      "AI Processor":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AI_Processor_Icon_7ea5b1e8-5ebe-48bb-bf31-59b53768e6b7.png?v=1760087967",
      "Google TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Google_TV_Icon_c69d8cb0-7904-4bf2-926c-b4ee0c32df08.png?v=1760087967",
      "4K Ultra HD":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/4K_Ultra_HD_Icon_42e55df4-7723-4522-8708-492f4e41efba.png?v=1760087966",
      "120Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120Hz_Icon_39074d28-02c0-433b-8d4f-6b6490c3f15d.png?v=1760087967",
      "Dolby Vision":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_Icon_bfb82158-81d3-48e8-a7c1-f0fe6f5a97fd.png?v=1760087966",
      "Dolby Atmos":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Atmos_Icon_eec9ad2a-55ca-4dd7-89f9-13736924ccca.png?v=1760087967",
      "HDR10+":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_ae9d0293-df68-4937-b7c3-039d6ee82341.png?v=1760087966",
      "Filmmaker Mode":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Filmmaker_Mode_Icon_975463d3-8102-4d98-859c-16b03de2c335.png?v=1760087967",
      "MEMC Real Motion":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MEMC_Real_Motion_Icon_2d35d8cb-8a7c-4e9c-a085-465400b8e9ba.png?v=1760087967",
      "Dbx-TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dbx-TV_Icon_ecd35df2-6d41-4de3-83b6-b3baf28a8d3a.png?v=1760087967",
      "Eye-Care":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Eye-Care_Icon_888b38e2-61e3-4837-a5c0-1442ab976bd8.png?v=1760087966",
      HDR10:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_a7449031-6c69-46c6-a018-68711b50d8d2.png?v=1760087965",
      "144Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/144Hz_Icon_ba9710fd-ba5f-4e43-8a5e-0df9eb4bd970.png?v=1760087966",
      "Dolby Vision IQ":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_IQ_Icon_7319f882-8c1a-4a35-abb3-cdc2553ec92f.png?v=1760087966",
      "Dolby Audio":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Audio_icon_48f32d34-e8e0-452b-987d-7557ab4e0cea.png?v=1760087966",
      DTS: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/DTS_Icon_563f56fb-90ac-49a5-9dbb-42a6a10a89c2.png?v=1760087966",
      // OmniView:
      //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/OmniView_Icon_e260087b-be29-41b1-b453-95594f6c478d.png?v=1761551263",
      "Apple Airplay":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Apple_Airplay.jpg?v=1765515832",
      "120Hz New":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120hz_icon_b793bf94-1475-4bd3-a3db-2b5d7f78f067.png?v=1766572727",
      "HDR10+ Gaming":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Gaming_black.png?v=1773979307",
      Omniview: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Omniview.png?v=1775614539",
    };

    return icons;
  }
})();
